<template lang="pug">
  .swatch-selector(v-if="!!this.formatedColorMatches")
    .title.xs-font-xlarge.md-font-grande.max-at-tweak.text-center Remember these gorgeous shades?
    HorizontalScroller(:scrollLock="!scrollable")
      .swatches-wrap.flex-box
        .swatch.xs-f-small.max-at-tweak(v-for="(match, index) in formatedColorMatches" :key="index")
          a.btn-reset.flex-box.column.center-minor-axis(:href="'/product/' + match.product.url_key" :aria-label="match.product.name + ' product page'")
            .swatch-image.non-focusable(tabindex="-1")
              .a-box-xs-1x1
                .a-box-content
                  ImgBox(:mediaId="getWavyBackieMediaId(match)") 
            .match-type.color-slate.xs-f-xxsmall.max-at-tweak.semi-bold.upper {{match.label}}

          .description {{match.description}}
          Stars.inline-block(:productId="match.product.id" :showReviewsCount="true")

        button.more-colors.btn-reset.xs-f-small.max-at-tweak(type="button" ref="moreColors" @click="seeMoreColors")
          .color-white.text-center.upper
            span more<br/> colors
            .icon-pos-circle.xs-f-xlarge.max-at-tweak

</template>

<script>
  import { mapActions, mapMutations, mapState } from 'vuex';
  import HorizontalScroller from '../../../HorizontalScroller';
  import ImgBox from '../../../imgBox';
  import Stars from '../../../stars';

  export default {
    name: "ColorMatchSwatchSelector",
    components: {
      HorizontalScroller,
      ImgBox,
      Stars,
    },

    inject: ['getObjProperty'],

    computed: {
      ...mapState('moreColorOptions', ['selectedColor']),
      ...mapState('colorAdvisor', ['colorMatches']),

      scrollable() {
        const bp = this.getObjProperty(this.$root.windowData, 'breakpoint');
        return ['mobile', 'tablet'].includes(bp);
      },

      formatedColorMatches() {
        if (Object.keys(this.colorMatches.data).length === 0) {
          return;
        }

        const codeHmap = {};
        const matches = []; 

        const colorMatches = this.colorMatches.data;

        const uniqueMatch = (checkKey) => {
          // helper function to check if a match's color has already been pushed to matches array
          // we exclude certain matches from being shown if its color is already included in another match
          return !codeHmap[colorMatches[checkKey].code]; 
        }

        // picks out color matches by match type
        // returning an array explicitly ordered by the conditional statements 
        if (colorMatches.bestMatch) {
          matches.push({
            key: 'bestMatch',
            label: 'best match',
            description: colorMatches.bestMatch.short_description,
            product: colorMatches.bestMatch
          });
          codeHmap[colorMatches.bestMatch.code] = 1;
        }

        if (colorMatches.mostPopular) {
          matches.push({
            key: 'mostPopular',
            label: 'most popular',
            description: colorMatches.mostPopular.short_description,
            product: colorMatches.mostPopular
          });
          codeHmap[colorMatches.mostPopular.code] = 1;
        }

        if (colorMatches.customerMatch && uniqueMatch('customerMatch')) {
          matches.push({
            key: 'customerMatch',
            label: 'your choice',
            description: colorMatches.customerMatch.short_description,
            product: colorMatches.customerMatch
          });
          codeHmap[colorMatches.customerMatch.code] = 1;
        }

        if (colorMatches.coloristMatch && uniqueMatch('coloristMatch')) {
          matches.push({
            key: 'coloristMatch',
            label: `colorist's choice`,
            description: colorMatches.coloristMatch.short_description,
            product: colorMatches.coloristMatch
          });
          codeHmap[colorMatches.coloristMatch.code] = 1;
        }

        if (colorMatches.translatorMatch) {
          matches.push({
            key: 'translatorMatch',
            label: 'translator results',
            description: colorMatches.translatorMatch.short_description,
            product: colorMatches.translatorMatch
          });
          codeHmap[colorMatches.translatorMatch.code] = 1;
        }

        return matches;
      },
    },

    methods: {
      ...mapActions('colorAdvisor', ['updateColorMatches', 'isAdvisorComplete']),
      ...mapActions('moreColorOptions', ['openPlaygroundModal']),
      ...mapMutations('moreColorOptions', ['setSelectedColor']),

      getWavyBackieMediaId(match) {
        return this.getObjProperty(match, 'product.imagery.pdpCarouselLarge.0.mediaId');
      },

      seeMoreColors() {
        this.isAdvisorComplete().then((isComplete) => {
          if (!isComplete) {
            return window.location.assign('/color-advisor');
          }

          // try to assign a default color assigned in color playground by looking through the color matches
          const colorMatches = this.colorMatches.data;
          let product;
          
          for (let match in colorMatches) {
            if (colorMatches[match]){
              product = colorMatches[match];
              break;
            }
          }

          if (!this.selectedColor) {
            this.setSelectedColor(product);
          }

          this.openPlaygroundModal({
            props: {
              viewOnModel: true,
              product: product || {},
            },
            returnFocusElement: this.$refs.moreColors,
          });
        });
      },
    },

    beforeMount() {
      if (this.colorMatches.updated === 0) {
        this.updateColorMatches();
      }
    }
  }

</script>

<style scoped lang="stylus">
  .swatch-selector
    margin 0 5%
    padding 3em 0
    .title
      margin 0 5%

    .swatches-wrap 
      flex-wrap nowrap
      justify-content flex-start
      margin-left 5%
      .swatch
        flex-basis 200px
        .swatch-image
          width 50vw
          max-width 200px
          background darken(color-fog-light, 5%)

        .match-type
          display inline-block
          border-radius 13.5px
          border solid 1px color-fog-light
          background-color color-white         
          padding 4px 22px 
          transform translateY(-50%)

        .description
          width 80%

      .more-colors
        > *
          width 50vw
          height 50vw
          max-width 200px
          max-height 200px
          background color-mr-purple
          border-radius 8px
          display flex
          flex-direction column
          align-items center
          justify-content center

      > *
        margin-right 5%
        margin-top 3em

  @media mq-tablet-plus
    .swatch-selector
      .title
        margin 0 0

      .swatches-wrap
        margin-left 0%

  @media mq-desktop-md-plus
    .swatch-selector
      .swatches-wrap
        flex-wrap wrap

        > *
          margin-right 2.5% 
          margin-top 3em;

</style>
